import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/politica-de-privacidade")({
  head: () => ({
    meta: [
      { title: "Política de Privacidade — Dr. Ulisses Contente" },
      {
        name: "description",
        content:
          "Política de Privacidade do site do Dr. Ulisses Contente, em conformidade com a LGPD (Lei 13.709/2018).",
      },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: PoliticaPrivacidade,
});

function PoliticaPrivacidade() {
  return (
    <main className="min-h-screen bg-[#F7F6F3] text-[#1C1C1E]">
      <div className="mx-auto max-w-[720px] px-6 py-14 md:py-20">
        <Link
          to="/"
          className="text-[14px] text-[#17724F] underline"
        >
          ← Voltar
        </Link>

        <h1 className="mt-6 font-bold text-[30px] md:text-[36px] leading-[1.2]">
          Política de Privacidade
        </h1>
        <p className="mt-3 text-[14px] text-[#6B6B70]">
          Última atualização: 2026.
        </p>

        <div className="mt-8 flex flex-col gap-6 text-[16px] text-[#3A3A3E] leading-[1.7]">
          <section>
            <h2 className="text-[20px] font-semibold text-[#1C1C1E]">1. Quem somos</h2>
            <p className="mt-2">
              Esta Política descreve como o Dr. Ulisses Contente, médico inscrito no CRM/SP 245805, em conjunto com [Razão social], CNPJ [número] (doravante "nós"), coleta, utiliza e protege os dados pessoais dos usuários deste site, em conformidade com a Lei Geral de Proteção de Dados — LGPD (Lei nº 13.709/2018).
            </p>
          </section>

          <section>
            <h2 className="text-[20px] font-semibold text-[#1C1C1E]">2. Dados coletados</h2>
            <p className="mt-2">
              Coletamos apenas os dados fornecidos voluntariamente por você por meio do formulário de contato: nome, telefone (WhatsApp), e-mail e respostas a perguntas de qualificação relacionadas ao atendimento. Também podemos coletar dados de navegação anônimos (por exemplo, páginas visitadas e origem do acesso) por meio de ferramentas de análise.
            </p>
          </section>

          <section>
            <h2 className="text-[20px] font-semibold text-[#1C1C1E]">3. Finalidade do uso</h2>
            <p className="mt-2">
              Os dados são utilizados exclusivamente para: (i) verificar se o atendimento é adequado ao seu caso; (ii) entrar em contato para agendamento; (iii) melhorar a experiência do site. Não vendemos, alugamos ou compartilhamos seus dados com terceiros para fins de marketing.
            </p>
          </section>

          <section>
            <h2 className="text-[20px] font-semibold text-[#1C1C1E]">4. Base legal</h2>
            <p className="mt-2">
              O tratamento é realizado com base no consentimento do titular (art. 7º, I da LGPD) e na execução de procedimentos preliminares a contrato (art. 7º, V).
            </p>
          </section>

          <section>
            <h2 className="text-[20px] font-semibold text-[#1C1C1E]">5. Armazenamento e segurança</h2>
            <p className="mt-2">
              Os dados são armazenados em ambiente seguro e mantidos apenas pelo tempo necessário para atender às finalidades descritas ou para cumprir obrigações legais. Adotamos medidas técnicas e administrativas razoáveis para protegê-los contra acesso não autorizado.
            </p>
          </section>

          <section>
            <h2 className="text-[20px] font-semibold text-[#1C1C1E]">6. Direitos do titular</h2>
            <p className="mt-2">
              Você pode, a qualquer momento, solicitar: confirmação da existência de tratamento; acesso, correção, anonimização ou eliminação de seus dados; portabilidade; e revogação do consentimento. As solicitações devem ser feitas pelo canal de contato indicado abaixo.
            </p>
          </section>

          <section>
            <h2 className="text-[20px] font-semibold text-[#1C1C1E]">7. Contato</h2>
            <p className="mt-2">
              Para exercer seus direitos ou tirar dúvidas sobre esta Política, entre em contato pelo e-mail [e-mail].
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}
